import React from 'react'

const SvgComponent = props => (
  <svg width={77} height={77} {...props}>
    <defs>
      <path id="fortress__prefix__a" d="M0 .196h35.448v19.898H0z" />
      <linearGradient
        x1="122.772%"
        y1="50%"
        x2="0%"
        y2="50%"
        id="fortress__prefix__b"
      >
        <stop stopColor="#F7E0E0" offset="0%" />
        <stop stopColor="#FFF" offset="100%" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <rect width={77} height={77} rx={20} fill="#E13F5E" />
      <g transform="translate(21 21)">
        <mask id="fortress__prefix__c" fill="#fff">
          <use xlinkHref="#fortress__prefix__a" />
        </mask>
        <path
          d="M16.537 19.635c.87.625 2.028.61 2.88-.037l16.03-12.163c.004-.005 0-7.218 0-7.218a.02.02 0 0 0-.021-.021h-8.883a.02.02 0 0 0-.02.02v1.861c0 1.159-.867 2.206-2.025 2.257a2.12 2.12 0 0 1-2.216-2.118v-2a.02.02 0 0 0-.02-.02H13.56a.02.02 0 0 0-.02.02v1.841c0 1-.785 2.065-1.769 2.243a2.175 2.175 0 0 1-2.577-2.136V.216a.02.02 0 0 0-.021-.02H.02L0 .216v7.537l16.537 11.882z"
          fill="url(#fortress__prefix__b)"
          mask="url(#fortress__prefix__c)"
        />
      </g>
      <path
        d="M20.437 22.29c-.73.553-1.593.83-2.456.83a4.055 4.055 0 0 1-2.372-.768L2.345 12.9l-.13 14.567a8.199 8.199 0 0 0 8.204 8.272l14.806-.008a8.2 8.2 0 0 0 8.192-8.038l.305-15.508L20.437 22.29z"
        fill="url(#fortress__prefix__b)"
        transform="translate(21 21)"
      />
    </g>
  </svg>
)

export default SvgComponent
